<template>
  <memlist-modal 
    ref="passwordModal"
    :title="$t('MEMBER.PASSWORD')">
    <m-row class="mt-4">
      <m-col lg="12">
        <memlist-text-input
          :title="$t('MEMBER.PASSWORD')"
          id="member-password"
          v-model="password"
          placeholder=""
          :state="validatePassword"
          type="password"
          autocomplete="off"
        />
        
      </m-col>
    </m-row>
    <m-row class="mt-4">
      <m-col lg="12">
        <memlist-text-input
          :title="$t('MEMBER.REPEAT_PASSWORD')"
          id="member-password2"
          v-model="password2"
          placeholder=""
          :state="validatePassword2"
          type="password"
          autocomplete="off"
        />
        
      </m-col>
    </m-row>
    <m-row class="mt-8 mb-8">
      <m-col lg="12">
        <RightModalSaveAndCloseButtons
          :text="$t('COMMON.SAVE')"
          :spin="true"
          @click="onUpdatePasswordClicked"
          @close="$refs['passwordModal'].hide()"
          ref="saveButton"
        />
      </m-col>
    </m-row>
  </memlist-modal>
</template>


<script>
import axios from 'axios';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

import RightModalSaveAndCloseButtons from '@/view/components/buttons/RightModalSaveAndCloseButtons.vue';

export default {
  name: 'user-update-password-modal',
  data() {
    return {
      password: null,
      password2: null
    };
  },

  components: {
    RightModalSaveAndCloseButtons
  },
  mixins: [ toasts ],
  props: ['user','is_me'],
  emits: ['cancel'],
  async mounted() {
    this.password = null;
    this.password2 = null;
  },
  methods: {
    show() {
      this.$refs['passwordModal'].show();
    },
    async onUpdatePasswordClicked() {
      await this.updatePassword(this.password);
      this.$refs['saveButton'].stop();
      this.$refs['passwordModal'].hide();
    },
    onCancel() {
      this.$refs['passwordModal'].hide();

      this.$emit('cancel');
    },

    async updatePassword(password) {

      try {

        let res = null;

        if (this.is_me) {
          res = await axios.put(`/access/user/me`, { password: password });
        }
        else {
          res = await axios.post(`/access/user/password`, { user_id: this.user.user_id, password: password });
        }

        if (res.status == 204) {
          this.toastr('success', this.$t('COMMON.OK'), this.$t('MEMBER.PASSWORD_UPDATED'));
        } else {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('MEMBER.UNABLE_PASSWORD_UPDATE'));
        }

      }
      catch (err) {
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('MEMBER.UNABLE_PASSWORD_UPDATE'));
      }

    },


  },
  computed: {
    validatePassword() {
      if (!this.password || ((this.password+'').length) < 6) {
        return false;
      }

      return true;
    },

    validatePassword2() {
      return this.password === this.password2;
    },


  }
};
</script>
